import { constantTree } from "../../../core/events/ConstantTree";

export const checkoutTree = constantTree({
    Init: "",
    PassengerDetails: {
        Init: "",
        UpdatePassengerData: "",
        SyncCustomerPassenger: "",
        Select: "",

        RememberMe: {
            Change: ""
        },
        Change: "",
        Unmount: ""
    },
    CustomerContact: {
        Change: ""
    },
    QuickExchangePayment: {
        Click: ""
    },
    Guest: {
        Payment: {
            Click: ""
        }
    },
    Payment: {
        Change: "",
        Click: "",
        RedirectToGateway: "",
        SaveCard: {
            Change: ""
        }
    },
    Seating: {
        Popup: {
            openClose: ""
        },
        Confirm: {
            Click: ""
        },
        Get: {
            PlaceMap: "",
            FloorPlanIcon: ""
        },
        Coach: {
            Set: "",
            getLayout: ""
        },
        Seat: {
            Select: "",
            PreSelect: "",
            DefaultSeatAllocation: "",
            Cursor: ""
        },
        UnavailableSeat: {
            Set: ""
        }
    },
    Confim: {
        Click: ""
    },
    Invoice: {
        Init: "",
    },
    EarnPoint:{
        GetPoints: ""
    }
})